import { PAGE_TYPE } from '../../constants/logger';
import onLogError from '../../utils/onLogError';
import { createPromiseFunctionWithDelay } from '../../utils/promise';
import './../../shop/modules/multi_checkout/services.multi-checkout';
import './../../shop/modules/services.family-mart';
import { DESTINATION_TYPES } from './constants/destinationType';
app.directive('destinationSectionFamilyMart', [
  'mainConfig',
  'familyMartService',
  'multiCheckoutService',
  function (mainConfig, familyMartService, multiCheckoutService) {
    return {
      restrict: 'E',
      templateUrl: require('../../../../../public/themes/shared/multi_checkout/templates.destination-section.family-mart.html'),
      scope: {
        store: '=',
        disabled: '=',
        cartTagIds: '=',
        errorMessage: '=',
        updateDestination: '<',
      },
      link: function (scope) {
        scope.actionUrl = familyMartService.FAMILY_MART_E_MAP;
        scope.cvstemp = mainConfig.merchantData._id;
        scope.cvsname = mainConfig.familyMartConfig.cvsname;

        const trackerPromiseWithDelay = createPromiseFunctionWithDelay(() => {
          multiCheckoutService.trackFillRecipientData(
            DESTINATION_TYPES.SAVE_STORE_MAP_FAMILY_MART,
          );
        });

        scope.onEMapSubmitClick = (event) => {
          event.preventDefault();
          scope
            .updateDestination()
            .then(() =>
              Promise.all([
                multiCheckoutService.saveSessionData({
                  cart_tag_ids: scope.cartTagIds,
                }),
                trackerPromiseWithDelay(),
              ]),
            )
            .then(() => {
              // No need to get domain token when env is production.
              if (mainConfig.familyMartEnv === 'prod') {
                $('#multi_checkout_family_mart')[0].submit();
                return;
              }
              familyMartService
                .getDomainToken()
                .then(({ data = {} }) => {
                  $('#multi_checkout_family_mart')
                    .find('input[name=cvstemp]:first')
                    .attr('value', data.token);
                  $('#multi_checkout_family_mart')[0].submit();
                })
                .catch((error) => {
                  console.error(error);
                });
            })
            .catch((error) => {
              onLogError({
                error,
                page: PAGE_TYPE.cart,
                debugMessage: 'unable to open e-map of family mart.',
                sourceName: 'destinationSectionFamilyMart#onEMapSubmitClick',
              });
            });
        };
      },
    };
  },
]);
